/**
 * Get visible domains for a role.
 *
 * @param {string} role - User role: student, faculty, admin, hod, placement
 * @returns {string[]} Array of domain IDs visible to this role
 */

import { ROLE_DOMAIN_VISIBILITY, NIRMAN_DOMAINS } from './domainConfig';

export function getRoleVisibleDomains(role) {
  if (!role) return [];

  const domainIds = ROLE_DOMAIN_VISIBILITY[role];
  if (!domainIds) return [];

  // Return only domains that exist in NIRMAN_DOMAINS
  return domainIds.filter(id => NIRMAN_DOMAINS[id]);
}

/**
 * Get visible domain objects for a role (with full metadata).
 *
 * @param {string} role - User role
 * @returns {Object[]} Array of domain objects (id, label, icon, etc.)
 */
export function getRoleVisibleDomainObjects(role) {
  const visibleIds = getRoleVisibleDomains(role);
  return visibleIds.map(id => NIRMAN_DOMAINS[id]).sort((a, b) => a.order - b.order);
}

export default getRoleVisibleDomains;
